module.exports = __webpack_public_path__ + "static/pic27-454f29da1fe85cf499f16f98a7a1b3a9.jpg";